// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import Card from 'common/components/Card';
import Proposition from 'common/modules/proposition/domain/proposition';
import PropositionDetail from 'common/modules/sales/components/PropositionDetail';

const Title = styled.h1`
  margin: 0;
  text-align: center;
`;

const DateText = styled.h2`
  padding-top: ${({ theme }) => theme.metrics.smallMargin}px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 22px;
`;

const InformationWrapper = styled(Card)`
  margin: ${({ theme }) => theme.metrics.margin}px auto;
  display: flex;
  width: 80%;
  justify-content: space-between;
`;

const Information = styled.div`
  padding: ${({ theme }) => theme.metrics.margin}px;
  min-width: 50%;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 15px;

  div {
    font-size: 18px;
  }
`;

type Props = {
  proposition: Proposition,
  hideTitle?: boolean,
  t: any,
  theme: any,
  className: ?String,
};

function PropositionDetailsContent(props: Props) {
  const { theme, t, proposition, hideTitle } = props;
  const title = proposition && proposition.title;
  const proposedOn = proposition && proposition.proposedOn;
  const proposedText = proposedOn && t('proposedOnDate', { date: proposedOn });
  const dateRange = proposition && proposition.dateRange;
  const rangeText = dateRange && t('campaignDateDisplay', { from: dateRange.from, to: dateRange.to });
  const description = proposition && proposition.description;
  const notes = proposition && proposition.notes;

  return (
    <div className={props.className}>
      {!hideTitle && <Title style={theme.fonts.style.overviewRadioTitle}>{title.toUpperCase()}</Title>}
      {rangeText && <DateText>{rangeText}</DateText>}
      {proposedText && <DateText>{proposedText}</DateText>}
      {description &&
        <InformationWrapper>
          <Information>
            <div>{t('description')}</div>
            {description}
          </Information>
        </InformationWrapper>
      }
      <PropositionDetail
        proposition={proposition}
      />
      {notes &&
        <InformationWrapper>
          <Information>
            <div>{t('notes')}</div>
            {notes}
          </Information>
        </InformationWrapper>
      }
    </div>
  );
}

export default translate('commonSales')(withTheme(PropositionDetailsContent));



// WEBPACK FOOTER //
// ./src/common/modules/proposition/components/PropositionDetailsContent.js